import { Progress, ProgressProps } from '@chakra-ui/react';
import type { FC } from 'react';
export type QProgressProps = ProgressProps;

export const QProgress: FC<QProgressProps> = (props) => {
  return <Progress borderRadius="sm" {...props} />;
};
